<template>
  <div>
    <ProductCustomizationFilters
      @updateFilterId="(filter) => updateFilterId(filter)"
      @setLoading="(options) => setLoading(options)"
      :shouldRefresh="shouldRefresh"
    ></ProductCustomizationFilters>

    <div class="col-lg-12 main-content-area">
      <br />
      <div class="row shoplist" style="margin-top: 15px">
        <ul>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(product, index) in products" :key="index">
            <div class="row width-100" @click="() => selecionarProduto(product)">
              <Product :product="product" />
            </div>
          </div>
        </ul>
      </div>

      <div class="text-center">
        <Loader v-if="loadingProducts" style="margin: 30px auto" />
      </div>

      <div v-if="!loadingProducts && !this.products.length && !this.notFound" class="text-center alert alert-warning">
        <i class="fa fa fa-exclamation fa-lg" style="margin-right: 6px"></i>Preencha os filtros acima para buscar
      </div>

      <div v-if="this.notFound" class="text-center alert alert-warning">
        <i class="fa fa fa-exclamation fa-lg" style="margin-right: 6px"></i>Não foi encontrado nenhum produto
      </div>

      <div v-show="!loadingProducts && this.products.length > 0" class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4 col-only-button">
          <div class="text-center">
            <button aria-label="Carregar Mais" class="btn primary-button stretch" v-on:click.prevent="loadMore()">
              <strong>Carregar Mais</strong>
            </button>
          </div>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from './Product.vue'
import ProductCustomizationFilters from './ProductCustomizationFilters.vue'
import Loader from '../Loader.vue'

export default {
  name: 'ProductListCustomization',
  props: ['clear', 'shouldRefresh'],
  data() {
    return {
      clearProducts: true,
      loadingProducts: false,
      products: [],
      notFound: false,
      offset: 0,
      order: 1,
      searchId: null,
      tipoSistema: ''
    }
  },
  components: {
    Product,
    ProductCustomizationFilters,
    Loader,
  },
  mounted() {
    this.setLoading({ loading: false, clearProducts: true })
  },

  methods: {
    loadProducts: function () {
      this.setLoading({ loading: true })

      if (this.clearProducts) {
        this.products = []
        this.offset = 0
        this.notFound = false
      }

      const url = new URL(location.href)
      const filtro = url.searchParams.get('filtro')

      const xhr = new XMLHttpRequest()

      xhr.onload = () => {
        if (xhr.status == 200) {

          const json = JSON.parse(xhr.responseText)

          const produtos = json.Produtos;

          produtos.forEach((element) => {
            const produto = {}
            produto.id = element.produto_id
            produto.code = element.produto_id + '-' + element.prd_codigodv
            produto.name = element.psg_descricao + ' ' + element.pgr_descricao
            produto.state = 'PR'
            produto.img = element.prd_caminho
            produto.description = element.prd_descricao
            produto.url = '/loja/produto/' + produto.code + '/' + element.URL
            produto.promotionalPrice = element.prd_precode
            produto.price = element.prd_preco
            produto.showActions = true
            produto.isLogged = element.is_logged
            produto.prdQtdeUnidade = element.prd_qtdeUnid
            produto.qtd = element.prd_qtdeUnid
            produto.productSelos = element.Selos
            produto.potencia = element.potencia > 0 ? element.prd_preco / (element.potencia * 1000) : 0;
            produto.gerador = element.gerador;
            produto.wallbox = element.wallbox;
            produto.potenciaGerador = element.prd_potenciaGerador;
            produto.potenciaInversor = element.prd_potenciaInversor;
            produto.mppt = element.prd_mppt;
            produto.tensao = element.prd_tensao;
            produto.fase = element.prd_fase;
            produto.selecionado = false

            this.products.push(produto)
          })

          if (this.products.length == 0) {
            this.notFound = true
          }

          this.clearProducts = true
        }
        this.setLoading({ loading: false })
      }

      console.log('Passei por aqui')
      xhr.open('POST', this.$apiUrl + 'Produto.svc/GetFiltroEProdutosPorSegmento')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.send(JSON.stringify({
        slug: `energia-solar/gerador-de-energia-solar-fotovoltaico${this.tipoSistema ? `/${this.tipoSistema}` : ""}`,
        origem: 'categoria',
        filtroAtributos: filtro,
        offset: this.offset,
        orderby: this.order,
      }));
    },

    selecionarProduto(product) {
      this.products.forEach((x) => {
        x.selecionado = false
      })

      product.selecionado = true

      this.$emit('updateCodigoProduto', product.id)
    },

    updateFilterId({ tipoSistema, id }) {
      this.tipoSistema = tipoSistema;
      this.searchId = id
      this.loadProducts()
    },

    loadMore: function () {
      this.offset += 1
      this.clearProducts = false

      this.loadProducts()
    },

    setLoading: function (options) {
      if (options.clearProducts) {
        this.products = []
        this.offset = 0
      }
      this.loadingProducts = options.loading
    },
  },

  watch: {
    clear() {
      this.products = []
    },
  },
}
</script>
